<template>
	<transition name="scroll-y-reverse-transition" v-if="module">
		<div ref="html" class="d-flex justify-center" v-html="module.html" v-intersect.once.quiet="loadScripts"></div>
	</transition>
</template>

<script>
export default {
	name: 'custom-html-module',
	props: ['module'],
	data: () => ({
		loading: 0
	}),
	methods: {
		loadScripts() {
			const scripts = this.module.html.match(/<script[\s\S]*?>[\s\S]*?<\/script>/gi) || [];
			for (let script of scripts) {
				this.loading++;
				const $script = document.createElement('script');
				$script.src = Object(script.match(/src=['"](.*?)['"]/))[1];
				$script.async = script.includes('async');
				$script.defer = script.includes('defer');
				$script.onload = () => {
					this.loading--;
				};
				this.$refs.html.appendChild($script);
			}
		}
	}
};
</script>
